'use es6';

import I18n from 'I18n';
import Raven from 'raven-js';
import { memo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { InfoIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Small from 'UIComponents/elements/Small';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimeZoneMessage = () => {
  try {
    const timestamp = I18n.moment().portalTz();
    const offsetString = timestamp.format('Z');
    return /*#__PURE__*/_jsxs(Flex, {
      marginBlockStart: "400",
      justifyContent: "end",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "timeZoneMessage.text",
          options: {
            offsetString
          }
        })
      }), /*#__PURE__*/_jsx(UITooltip, {
        placement: "top left",
        title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `timeZoneMessage.tooltip_jsx`,
          elements: {
            Link: UILink
          },
          options: {
            href: `/settings/${PortalIdParser.get()}/account-defaults/general`
          }
        }),
        children: /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-core-subtle",
          icon: InfoIcon,
          padding: "0",
          size: "300",
          marginInlineStart: "100"
        })
      })]
    });
  } catch (ex) {
    Raven.captureException(ex, {
      portalId: PortalIdParser.get()
    });
    return null;
  }
};
export default /*#__PURE__*/memo(TimeZoneMessage);